import React from 'react'
import { Container } from './styles'

interface Props {
  header: string[]
  items: string[][]
  actions?: React.ReactNode[]
  onClick: (item: string[]) => void
}

const Table: React.FC<Props> = ({ header, items, actions, onClick }) => {
  return (
    <Container>
      <table>
        <thead>
          <tr>
            {header.map((h, i) => (
              <th
                key={i}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {items.map((item, i) => (
            <tr
              key={i}
              onClick={() => onClick(item)}
            >
              {item.map((column, j) => (
                <td
                  key={j}
                >
                  {column || '-'}
                </td>
              ))}
              {
                (actions && actions.length) ? (
                  <td>
                    {actions[i]}
                  </td>): ''
              }
            </tr>
          ))}
        </tbody>
      </table>
    </Container>
  )
}

export default Table
